import React from 'react';
import { EditBase, usePermissions, useRedirect, useResourceContext } from 'react-admin';
import SimpleFormCustom from '../../Components/Form/SimpleFormCustom';
import Form from './Form';
import CreateHeader from '../../Components/Form/CreateHeader';

const Edit = () => {
  const { permissions } = usePermissions();
  const redirect = useRedirect();
  const resource = useResourceContext();
  const goBack = () => {
    redirect(`/${resource}`);
  };

  return (
    <EditBase mutationMode='optimistic'>
      <SimpleFormCustom
        sx={{ display: 'flex', flexDirection: 'column' }}
        hasDelete={permissions === 'superadmin'}
        messageDelete={{
          confirmContent: '¿Estas seguro de eliminar este usuario?',
          confirmTitle: 'Eliminar usuario'
        }}
        header={<CreateHeader goBack={goBack} label='' isEdit={true}/>}
      >
        <Form />
      </SimpleFormCustom>
    </EditBase>
  );
};

export default Edit;